import React, { useEffect, useState } from "react";
import Promo from "./promo";
import { IContainerProps } from "./promointerface";
import { selectors as headerSelector } from "../../../../state/features/header";
import { useSelector } from "react-redux";
import partsService from "../../../../services/partsservice";
import helperfunctions from "../../../../utils/helperfunctions";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../../const/resource";
import { useCartContext } from './../../shoppingcart';
import { ICartContextType } from "../shoppingcartpromointerface";
import { selectors as globalDataSelector } from "../../../../state/features/common/globaldata";
import { confirmDailog } from "../../../ConfirmDailog";

const PromoContainer = (props: IContainerProps) => {
    const { t } = useTranslation();
    const { cartsDetails }: ICartContextType = useCartContext();
    const { headercurrentuser, globalData }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
        globalData: globalDataSelector.globaldata(state),
    }));

    const [apply, setApply] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [applyPromoRes, setApplyPromoRes] = useState({ loading: false, data: {} });
    const [deletePromoRes, setDeletePromoRes] = useState({ loading: false, data: {} });
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (headercurrentuser?.azureADId && cartsDetails?.cart?.cartId) {
            setApply(true);
        }
    }, [headercurrentuser?.azureADId, cartsDetails?.cart?.cartId]);

    const handleInputChange = (e: any) => {
        setIsError(false);
        const newValue = e?.target?.value ? e?.target?.value?.length > 50 ? inputValue : e?.target?.value : '';
        setInputValue(newValue);
    };

    const handleKeyDown = async (event: any) => {
        if (event.key === "Enter") {
            await handleclick();
        }
    };

    const deletePromoCode = async (promo: any) => {
        try {
            setDeletePromoRes({ loading: true, data: {} });
            const reqBody = {
                userAadId: headercurrentuser?.azureADId,
                cartId: `${cartsDetails?.cart?.cartId ?? 0}`,
                promoCode: promo?.promoCode,
                distributorId: globalData?.DistributorCode,
                customerId: globalData?.CustomerId ? Number(globalData?.CustomerId) : 0
            }
            const response = await partsService.deletePromoCode(reqBody);
            if (response?.isSuccess) {
                if (response?.data?.isSuccessful) {
                    props?.isPromoCodeChangeUpdate(true);
                    props?.getCartItems();
                    helperfunctions.showSuccessMessage(response?.data?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Promo_DeletePromoCode_Success_Msg));
                }
                else {
                    helperfunctions.showErrorMessage(response?.data?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Promo_DeletePromoCode_Error_Msg));
                }
                setDeletePromoRes({ loading: false, data: response });
            } else {
                console.error('Error in deletePromoCode - ', response?.msg);
                setDeletePromoRes({ loading: false, data: response });
                helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Promo_DeletePromoCode_Error_Msg));
            }
        } catch (error) {
            setDeletePromoRes({ loading: false, data: {} });
            console.error('Exception in deletePromoCode - ', error);
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Promo_DeletePromoCode_Error_Msg));
        }
    };

    const onRemovePromoCode = (promo: any) => {
        const confimObject = {
            title: t(RESOURCE.MyK_Label_ShoppingCart_Promo_Remove_Confirmation),
            message: t(RESOURCE.MyK_Label_ShoppingCart_Promo_Remove_Confirmation_Msg),
            buttonLabel: {
                yes: t(RESOURCE.MyK_Label_OK),
                no: t(RESOURCE.MyK_Label_Cancel),
            },
            yesOnclick: () => {
                deletePromoCode(promo);
            },
            noOnclick: () => { },
        };
        confirmDailog(confimObject);
    };


    const handleclick = async () => {
        if (inputValue != "") {
            try {
                setApply(false);
                setApplyPromoRes({ loading: true, data: {} });
                const response = await partsService.applyPromoCode({
                    UserAadId: headercurrentuser?.azureADId,
                    cartId: `${cartsDetails?.cart?.cartId}`,
                    promoCode: `${inputValue ?? ''}`,
                    distributorId: globalData?.DistributorCode,
                    customerId: globalData?.CustomerId ? Number(globalData?.CustomerId) : 0
                }
                );
                if (response?.isSuccess) {
                    setApplyPromoRes({ loading: false, data: response?.data });
                    setInputValue('');
                    setApply(true);
                    if (response?.data?.isSuccessful) {
                        props?.isPromoCodeChangeUpdate(true);
                        props?.getCartItems();
                        props?.showPartCreditWhenPromoApplied();
                        helperfunctions.showSuccessMessage(response?.data?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Promo_Valid_Success_Msg));
                    } else {
                        helperfunctions.showErrorMessage(response?.data?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Promo_Invalid_Error_Msg));
                    }
                }
                else {
                    setApplyPromoRes({ loading: false, data: {} });
                    setApply(true);
                    helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Promo_Apply_Error_Msg));
                    console.error('Error in applyPromoCode - ', response?.msg);
                }
            } catch (error) {
                setApplyPromoRes({ loading: false, data: {} });
                setApply(true);
                helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Promo_Apply_Error_Msg));
                console.error('Exception in applyPromoCode - ', error);
            }
        } else {
            setIsError(true);
        }
    };

    return (
        <Promo
            inputValue={inputValue}
            handleInputChange={handleInputChange}
            applyPromoRes={applyPromoRes}
            apply={apply}
            handleclick={handleclick}
            getItemSummaryDetails={props?.getItemSummaryDetails}
            itemSummaryDetails={props?.itemSummaryDetails}
            onRemovePromoCode={onRemovePromoCode}
            deletePromoRes={deletePromoRes}
            isError={isError}
            handleKeyDown={handleKeyDown}
        />
    );
}

export default PromoContainer;
